import React from "react";
import Routers from "./routers/Routers";

function App() {
  return (
    <div>
        <Routers />
    </div>
  );
}

export default App;
